import FormattedMessage from 'I18n/components/FormattedMessage';
import PortalIdParser from 'PortalIdParser';
import CrmLogger from 'customer-data-tracking/loggers/CrmLogger';
import { Link } from 'foundations-components/transitional/components/Link';
import { jsx as _jsx } from "react/jsx-runtime";
const SocialProfileCardAction = () => {
  return /*#__PURE__*/_jsx(Link, {
    href: `/social-insights/${PortalIdParser.get()}/inbox`,
    "data-selenium-test": "social-profile-card-action",
    "data-test-id": "social-profile-card-action",
    onClick: () => CrmLogger.log('sidebar-interaction', {
      action: 'social profile - click manage'
    }),
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "cardAssociatedObjects.manageButton"
    })
  });
};
export default SocialProfileCardAction;